import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

// The onboarding guide is a standalone document (public/welcome.page.html): ~1900
// lines with its own stylesheet and the system-finder quiz script. It is framed here
// rather than ported into React so that it stays one page inside the app — same tab,
// app header and footer around it, and a URL the router owns.
//
// `embed=1` is what the document reads to drop its own header and to route every
// link through the top window, so links out of the guide land on real app routes.
const ONBOARDING_SRC = '/welcome.page.html?embed=1';

// Matches the AppBar's minHeight in Layout.tsx. The frame takes the rest of the
// viewport, so the guide scrolls inside it and the page around it never scrolls —
// one scrollbar, not two. dvh keeps it honest on mobile, where the browser chrome
// slides away and 100vh overshoots.
const FRAME_HEIGHT = {
  xs: 'calc(100dvh - 64px)',
  sm: 'calc(100dvh - 72px)',
};

// A hash on the app route (e.g. /onboarding#wizard) is handed to the frame so the
// guide opens at that section.
const Onboarding = () => {
  const { hash } = useLocation();
  return (
    <Box
      component="iframe"
      src={ONBOARDING_SRC + hash}
      title="Onboarding: your new heating and cooling system"
      sx={{
        display: 'block',
        width: '100%',
        height: FRAME_HEIGHT,
        border: 0,
      }}
    />
  );
};

export default Onboarding;
